import React from 'react'
import sharedClasses from '../../Auth/signup.module.css'
import classes from '../../Auth/SignIn.module.css'
import classNames from 'classnames'
import loginImage from '../../../assets/images/beneficiary-invite-image.jpg'
import { ReactComponent as ArrowRight } from '../../../assets/icons/arrow-right.svg'
import { ReactComponent as LeftIcon } from '../../../assets/icons/left.svg'
import { ValidatedLoginInput } from '../../../components/Form/Inputs/Inputs'
import { Button, ButtonIcon } from '../../../components/Button/Button'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { Formik } from 'formik'
import { useDispatch } from 'react-redux'
import useAuthForm from '../../../hooks/useAuthForm'
import { login } from '../../../api/authApi'
import { LoginSchema } from '../../../util/formSchemas'
import { UserTypes } from '../../../util/constants'
import { BeneficiaryTop } from './BeneficiarySignUp'
import useCompanyLogo from '../../../hooks/useCompanyLogo'
import Loading from '../../../components/loaders/Loading'
import { Redirect } from 'react-router'
import { getParentRoute } from '../../../util/functions'

const BeneficiarySignIn = ({ location, history, match }) => {
    const dispatch = useDispatch()

    const path = getParentRoute(location.pathname)

    useAuthForm(
        () => {
            history.push('/app/beneficiary/my-courses')
        },
        true,
        UserTypes.Beneficiary
    )

    const submitForm = values => {
        dispatch(login({ ...values, domainName }))
    }

    const { domainName } = match.params

    const logoProps = useCompanyLogo(domainName)

    if (logoProps.isFetching) {
        return <Loading />
    }

    if (logoProps.has404Error) {
        return (
            <Redirect
                to={{
                    pathname: '/app/404',
                    state: { finalDestination: true },
                }}
            />
        )
    }

    return (
        <div className={classNames(sharedClasses.container, classes.container)}>
            <Formik
                initialValues={{
                    email: '',
                    password: '',
                }}
                validationSchema={LoginSchema}
                onSubmit={submitForm}
            >
                {({ handleSubmit }) => (
                    <div
                        className={classNames(sharedClasses.form, classes.form)}
                    >
                        <BeneficiaryTop logoProps={logoProps} />
                        <h1 className={sharedClasses.formHeader}>
                            Welcome Back
                        </h1>
                        <div className={sharedClasses.formInputs}>
                            <ValidatedLoginInput
                                className={classes.input}
                                placeholder={'Email Address'}
                                name={'email'}
                            />
                            <ValidatedLoginInput
                                className={classes.input}
                                placeholder={'Password'}
                                name={'password'}
                                type={'password'}
                            />
                        </div>
                        <Button
                            className={sharedClasses.formButton}
                            smallRadius
                            onClick={handleSubmit}
                        >
                            Log In
                            <ButtonIcon
                                icon={
                                    <ArrowRight
                                        className={sharedClasses.formButtonIcon}
                                    />
                                }
                            />
                        </Button>
                        <span
                            className={classNames(
                                sharedClasses.formSplitLine,
                                classes.formSplitLine
                            )}
                        />
                        <p className={sharedClasses.formSignInText}>
                            Forgot your password?{' '}
                            <Link
                                to={`${path}/forgot-password`}
                                className={sharedClasses.formSignInTextOrange}
                            >
                                Reset it here
                            </Link>
                        </p>
                    </div>
                )}
            </Formik>
            <img
                src={loginImage}
                alt="Sign In"
                className={sharedClasses.displayImage}
            />
        </div>
    )
}

export default BeneficiarySignIn
